import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { IDeliveryList } from '../../../utils/types';
import { AppDispatch } from '../../../state';
import { FetchApi } from '../../../utils/fetch/fetchApi';
import { pathsApi } from '../../../router/paths';
import { setNotificationSuccess } from '../../../state/reducers/notification';
import i18n from '../../../utils/i18n';
import Button from '../../../ui/Button';
import { ButtonVariationEnum } from '../../../ui/Button/types';
import DragAndDropPopup from '../../../components/DragAndDrop/dragAndDropPopup';

interface ISortDelivery {
    deliveries?: Array<IDeliveryList>;
    setDeliveryCallback: (id: Array<IDeliveryList>) => void;
}

const SortDelivery = ({ deliveries, setDeliveryCallback }: ISortDelivery) => {
    const [isOpen, handleOpen] = useState<boolean>(false);
    const dispatch = useDispatch<AppDispatch>();

    const handleSaveSort = async (payload: Array<{ id: number; order: number }>) => {
        const response = await FetchApi.post<Array<IDeliveryList>>(pathsApi.deliverySort, {
            items: payload,
        });

        if (response?.length) {
            dispatch(setNotificationSuccess(i18n.general.updatedSuccessful));
            setDeliveryCallback(response);
            return true;
        }
        return false;
    };

    return (
        <>
            <Button
                onClick={() => {
                    handleOpen(true);
                }}
                variation={ButtonVariationEnum.SOFT}
                disabled={!deliveries?.length}
            >
                {i18n.delivery.deliverySort}
            </Button>
            {isOpen && deliveries && (
                <DragAndDropPopup
                    isOpen={!!isOpen}
                    handleClose={() => handleOpen(false)}
                    items={deliveries.map((item) => ({
                        id: item.id,
                        content: item.name,
                    }))}
                    submit={handleSaveSort}
                />
            )}
        </>
    );
};

export default SortDelivery;
